<template>
    <div class="category">
        <div class="category-title-button" @click="toggle">
            <div class="category-title">
                <Checkbox
                    v-if="category.osmdiff || category.objects"
                    @input="onChecked"
                    v-model="category.checked"
                />
                <slot name="title"></slot
                ><span :title="category.name"
                    >{{ category.name }}
                    <span v-if="category.osmdiff || category.objects">
                        ({{ category.nbThemeDiff || category.nbOsmDiff || 0 }})
                    </span>
                </span>
            </div>
            <span v-if="counter" class="category-count">{{ counter }}</span>
            <font-awesome-icon
                v-if="!isLoading"
                icon="angle-down"
                class="toggle"
                :class="{ active: open }"
            />
            <font-awesome-icon v-if="isLoading" icon="circle-notch" spin class="spinner" />
        </div>
        <div class="category-expand" :class="{ open: open }"><slot></slot></div>
    </div>
</template>

<script>
import Checkbox from '@/components/Checkbox';
export default {
    props: {
        category: Object,
        opened: Boolean,
        isLoading: Boolean,
        count: Number,
        selected: Array,
    },
    data() {
        return {
            open: false || this.opened,
        };
    },
    computed: {
        counter() {
            return this.count > 99 ? '99+' : this.count;
        },
    },
    methods: {
        toggle() {
            this.open = !this.open;
            this.category.opened = this.open;
        },
        onChecked(event) {
            // Cas où la catégorie est un groupe d'objets
            if (this.category.osmdiff) {
                this.checkObjectGroup(this.category, event);
            }
            // Cas où la catégorie est un thème
            if (this.category.objects) {
                for (let i = 0; i < this.category.objects.length; i++) {
                    const object = this.category.objects[i];
                    if (object.osmdiff) {
                        this.checkObjectGroup(object, event);
                    }
                }
            }

            return true;
        },
        checkObjectGroup(objectGroup, checked) {
            objectGroup.checked = checked;
            for (let i = 0; i < objectGroup.osmdiff.length; i++) {
                const osmdiff = objectGroup.osmdiff[i];
                if (checked === true) {
                    this.selected.push(osmdiff);
                } else if (checked === false) {
                    for (let ii = this.selected.length - 1; ii >= 0; ii--) {
                        const selected = this.selected[ii];
                        if (selected.id === osmdiff.id) {
                            this.selected.splice(ii, 1);
                        }
                    }
                }
            }
        },
    },
    components: {
        Checkbox,
    },
};
</script>

<style lang="scss">
.category {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 4px;
    padding-right: 2px;

    .category-title-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        user-select: none;

        .category-title {
            color: #2a2a2a;
            font-size: 11px;
            font-weight: bold;
            letter-spacing: 0.85px;
            line-height: 15px;
            display: flex;
            flex-direction: row;
            align-items: center;
            text-transform: uppercase;
            span {
                margin-left: 8px;
                font-size: 11px;
                font-weight: bold;
                letter-spacing: 0.85px;
                line-height: 15px;
                text-overflow: ellipsis;
                overflow: hidden;
                max-width: 100px;
            }
        }

        .category-count {
            color: #ffffff;
            background-color: #6c3e91;
            border-radius: 30px;
            width: 35px;
            text-align: center;
            position: absolute;
            right: 20%;
        }

        .toggle {
            color: #2a2a2a;
            transition: transform 0.25s ease;
            transform: rotate(-90deg);
            height: 20px;
            font-size: 20px;
            width: 14px;

            &.active {
                transform: rotate(0deg);
            }
        }

        .spinner {
            color: #2a2a2a;
            height: 20px;
            font-size: 20px;
            width: 14px;
        }
    }

    .filter-category {
        padding: 20px 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .category-expand {
        transition: all 5s ease-in-out;
        // overflow: hidden;
        // height: 0;
        display: none;

        &.open {
            // height: auto;
            display: block;
            transition: all 0.25s ease-in-out;
        }
    }

    // .category-expand-enter-active,
    // .category-expand-leave-active {
    //     transition: height 1s ease-in-out;
    //     overflow: hidden;
    // }

    // .category-expand-enter,
    // .category-expand-leave-to {
    //     height: 0;
    // }
}
</style>
